export const TableLabel = ({ children }: { children: string }) => {
  return <div className="text-caption-sm-a text-base-text-tertiary text-start">{children}</div>;
};
